import { useSelector } from "react-redux";
import "../../Style.css";

const InterviewDescription = ({onChange}) => {
  const {jobDescription} = useSelector((state)=> state.interviewconfig);
  return (
      <div>
      <label className="interview-description-label">
          Job Description
        </label>
        <textarea
          name="jobDescription"
          value={jobDescription}
        className="interview-description-textarea"
          rows="3"
          placeholder="Describe Job description..."
          onChange={onChange}
        ></textarea>
      </div>
  );
};

export default InterviewDescription;
